import {fetchData,getAccessControlInfo, getAccessScope, baseUrl} from './webAPIBase';
import log from '../helpers/logger';

export function GetAuthCol(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetAuthCol'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetAuthRow(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetAuthRow'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetScreenLabel(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenLabel'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope || getAccessScope())
        }
    )

}

export function GetLabels(labelCat,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetLabels'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    labelCat:labelCat
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetScreenButtonHlp(labelCat,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenButtonHlp'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetScreenHlp(labelCat,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenHlp'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetScreenCriteria(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenCriteria'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetNewMst(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetNewMst'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetNewDtl(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetNewDtl'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetScreenFilter(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenFilter'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetXrsBTrx48List(searchStr, topN, filterId,accessScope){
    log.debug(
        JSON.stringify({
            searchStr: searchStr || "",
            topN: topN || 0,
            filterId: ('' +  (filterId || 0)),
        }        
    ));
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetXrsBTrx48List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    searchStr: searchStr || "",
                    topN: topN || 0,
                    filterId: ('' +  (filterId || 0)),
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetXrsBTrx48ById(keyId,accessScope){
    log.debug('GetXrsBTrx48ById', keyId);    
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetXrsBTrx48ById'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    keyId: keyId || "",
                    options: {
                        currentScreenCriteria : JSON.stringify({}),
                    },
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetXrsBTrx48DtlById(keyId,filterId,accessScope){
    log.debug('GetXrsBTrx48DtlById', keyId);
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetXrsBTrx48DtlById'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    keyId: keyId || "",
                    options: {
                        currentScreenCriteria : JSON.stringify({}),
                    },
                    filterId: filterId || 0,
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetCompanyId64List(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetCompanyId64List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetProjectId64List(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetProjectId64List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetMember64IdList(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetMember64IdList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetCustomerJobId64List(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetCustomerJobId64List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetCurrencyId64List(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetCurrencyId64List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function GetBGlChartId65List(query, topN, filterBy,accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetBGlChartId65List'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function WrGetXrsBTrx48Dashboard(accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/WrGetXrsBTrx48Dashboard'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function LoadInitPage(options,accessScope) {
    const reqJson = JSON.stringify({
        options: options
    });
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/LoadInitPage'
        ,{
            requestOptions: {
                body: reqJson,
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}
export function SaveData(mst,dtl,options,accessScope){
    log.debug(mst,dtl,options);
    const reqJson = JSON.stringify({
        mst: mst,
        dtl: dtl,
        options: options
    });
    log.debug(reqJson);
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/SaveData'
        ,{
            requestOptions: {
                body: reqJson,
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function DelMst(mst,options,accessScope){
    const reqJson = JSON.stringify({
        mst: mst,
        options: options
    });
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/DelMst'
        ,{
            requestOptions: {
                body: reqJson,
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function SetScreenCriteria(criteriaValues, accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/SetScreenCriteria'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    criteriaValues: criteriaValues
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetScreenCriMemberIdDdlList(query, topN, filterBy, accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenCriteriaDdlList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    screenCriId: 1,
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetScreenCriCustomerJobIdDdlList(query, topN, filterBy, accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenCriteriaDdlList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    screenCriId: 6,
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetScreenCriCheckBoxCdDdlList(query, topN, filterBy, accessScope){
    return fetchData(baseUrl+'/XrsBTrxWs.asmx/GetScreenCriteriaDdlList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    screenCriId: 4,
                    query: query || "",
                    topN: topN || 0,
                    filterBy: filterBy || null
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}


// WEBPACK FOOTER //
// ./src/services/XrsBTrxService.js